import { chakra } from '@chakra-ui/react'
import { Form as VerbitForm } from '@verbit-ai/verbit-ui-library'

export const Form = chakra(VerbitForm, {
    baseStyle: {
        '& .form-scroll-container': {
            gap: '16px',
        },
        '& .verbit-form-field': {
            width: '100%',
            marginBottom: 0,
            padding: 0,
        },
    },
}) as typeof VerbitForm

Form.Select = chakra(VerbitForm.Select, {
    baseStyle: ({ theme }) => ({
        borderColor: theme.palette.verbitSelect.borderColor,

        '& .verbit-select': {
            '&__control.is-focused': {
                boxShadow: theme.palette.verbitSelect.focusedShadow,
            },
            '&__value-container': {
                gap: 0,
            },
            '&__single-value': {
                color: theme.palette.verbitSelect.valueColor,
            },
            '&__dropdown-indicator svg': {
                stroke: theme.palette.verbitSelect.indicatorColor,
            },
        },
    }),
}) as typeof VerbitForm.Select

Form.CheckboxGroup = VerbitForm.CheckboxGroup

Form.Checkbox = chakra(VerbitForm.Checkbox, {
    baseStyle: ({ theme }) => ({
        color: theme.palette.verbitCheckbox.labelColor,
        '& .chakra-checkbox__control': {
            borderColor: theme.palette.verbitCheckbox.boxBorderColor,
            "&[aria-checked='true'], &[data-checked]": {
                background: theme.palette.verbitCheckbox.checkedBoxBgColor,
                svg: {
                    stroke: theme.palette.verbitCheckbox.checkedBoxIconColor,
                },
            },
        },
    }),
}) as typeof VerbitForm.Checkbox
